// Bootstrap-select translations
// https://github.com/silviomoreto/bootstrap-select/tree/master/js/i18n

(function ($) {
  var languages = {
    ar: {
      noneSelectedText: 'لم يتم إختيار شئ',
      noneResultsText: 'لا توجد نتائج مطابقة لـ {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} خيار تم إختياره' : '{0} خيارات تمت إختيارها';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'تخطى الحد المسموح ({n} خيار بحد أقصى)' : 'تخطى الحد المسموح ({n} خيارات بحد أقصى)',
          numGroup === 1 ? 'تخطى الحد المسموح للمجموعة ({n} خيار بحد أقصى)' : 'تخطى الحد المسموح للمجموعة ({n} خيارات بحد أقصى)'
        ];
      },
      selectAllText: 'إختيار الجميع',
      deselectAllText: 'إلغاء إختيار الجميع',
      multipleSeparator: '، '
    },

    de: {
      noneSelectedText: 'Bitte wählen...',
      noneResultsText: 'Keine Ergebnisse für {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} Element ausgewählt' : '{0} Elemente ausgewählt';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'Limit erreicht ({n} Element max.)' : 'Limit erreicht ({n} Elemente max.)',
          numGroup === 1 ? 'Gruppen-Limit erreicht ({n} Element max.)' : 'Gruppen-Limit erreicht ({n} Elemente max.)'
        ];
      },
      selectAllText: 'Alles auswählen',
      deselectAllText: 'Nichts auswählen',
      multipleSeparator: ', '
    },

    fr: {
      noneSelectedText: 'Aucune sélection',
      noneResultsText: 'Aucun résultat pour {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected > 1 ? '{0} éléments sélectionnés' : '{0} élément sélectionné';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll > 1 ? 'Limite atteinte ({n} éléments max)' : 'Limite atteinte ({n} élément max)',
          numGroup > 1 ? 'Limite du groupe atteinte ({n} éléments max)' : 'Limite du groupe atteinte ({n} élément max)'
        ];
      },
      multipleSeparator: ', ',
      selectAllText: 'Tout sélectionner',
      deselectAllText: 'Tout désélectionner',
    },

    it: {
      noneSelectedText: 'Nessuna selezione',
      noneResultsText: 'Nessun risultato per {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? 'Selezionato {0} di {1}' : 'Selezionati {0} di {1}';
      },
      maxOptionsText: ['Limite raggiunto ({n} {var} max)', 'Limite del gruppo raggiunto ({n} {var} max)', ['elementi', 'elemento']],
      multipleSeparator: ', ',
      selectAllText: 'Seleziona Tutto',
      deselectAllText: 'Deseleziona Tutto'
    },

    nl: {
      noneSelectedText: 'Niets geselecteerd',
      noneResultsText: 'Geen resultaten gevonden voor {0}',
      countSelectedText: '{0} van {1} geselecteerd',
      maxOptionsText: ['Limiet bereikt ({n} {var} max)', 'Groep limiet bereikt ({n} {var} max)', ['items', 'item']],
      selectAllText: 'Alles selecteren',
      deselectAllText: 'Alles deselecteren',
      multipleSeparator: ', '
    },

    pt: {
      noneSelectedText: 'Nenhum seleccionado',
      noneResultsText: 'Sem resultados contendo {0}',
      countSelectedText: 'Selecionado {0} de {1}',
      maxOptionsText: ['Limite ultrapassado (máx. {n} {var})', 'Limite de seleções ultrapassado (máx. {n} {var})', ['itens', 'item']],
      multipleSeparator: ', ',
      selectAllText: 'Selecionar Tudo',
      deselectAllText: 'Desmarcar Todos'
    },

    ru: {
      noneSelectedText: 'Ничего не выбрано',
      noneResultsText: 'Совпадений не найдено {0}',
      countSelectedText: 'Выбрано {0} из {1}',
      maxOptionsText: ['Достигнут предел ({n} {var} максимум)', 'Достигнут предел в группе ({n} {var} максимум)', ['шт.', 'шт.']],
      doneButtonText: 'Закрыть',
      selectAllText: 'Выбрать все',
      deselectAllText: 'Отменить все',
      multipleSeparator: ', '
    },

    en: {
      noneSelectedText: 'Nothing selected',
      noneResultsText: 'No results match {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} item selected' : '{0} items selected';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
          numGroup === 1 ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
        ];
      },
      selectAllText: 'Select All',
      deselectAllText: 'Deselect All',
      multipleSeparator: ', '
    },

    es: {
      noneSelectedText: 'No hay selección',
      noneResultsText: 'No hay resultados {0}',
      countSelectedText: 'Seleccionados {0} de {1}',
      maxOptionsText: ['Límite alcanzado ({n} {var} max)', 'Límite del grupo alcanzado({n} {var} max)', ['elementos', 'element']],
      multipleSeparator: ', ',
      selectAllText: 'Seleccionar Todos',
      deselectAllText: 'Desmarcar Todos'
    },

    zh: {
      noneSelectedText: '没有选中任何项',
      noneResultsText: '没有找到匹配项',
      countSelectedText: '选中{1}中的{0}项',
      maxOptionsText: ['超出限制 (最多选择{n}项)', '组选择超出限制(最多选择{n}组)'],
      multipleSeparator: ', ',
      selectAllText: '全选',
      deselectAllText: '取消全选'
    },

    el: {
      noneSelectedText: 'Δεν έχει επιλεγεί τίποτα',
      noneResultsText: 'Δεν ταιριάζουν αποτελέσματα {0}',
      countSelectedText: 'επιλεγμένο {0} από {1}',
      maxOptionsText: ['Το όριο επετεύχθη ({n} {var} ανώτατο όριο)', 'Το όριο ομάδας έφθασε ({n} {var} στοιχεία ανώτατο όριο)', ['είδος', 'αντικειμένων']],
      doneButtonText: 'Κοντά',
      selectAllText: 'Επιλογή όλων',
      deselectAllText: 'Αποεπιλογή όλων',
      multipleSeparator: ', '
    },

    ca: {
      noneSelectedText: "No s'ha seleccionat res",
      noneResultsText: 'No hi ha resultats coincidents {0}',
      countSelectedText: 'Seleccionat {0} des de {1}',
      maxOptionsText: ["S'ha arribat al límit ({n} {var} màxim)", "S'ha arribat al límit del grup ({n} {var} màxim)", ['elements', 'article']],
      doneButtonText: 'Tanca',
      selectAllText: 'Seleccionar tot',
      deselectAllText: 'Deseleccionar tot',
      multipleSeparator: ', '
    },

    sr: {
      noneSelectedText: 'Ништа није изабрано',
      noneResultsText: 'Нема резултата {0}',
      countSelectedText: 'Изабрано {0} из {1}',
      maxOptionsText: ['Достигнут лимит ({n} {var} максимум)', 'Групни лимит достигнут ({n} {var} максимум)', ['комада', 'комада']],
      doneButtonText: 'Близу',
      selectAllText: 'Изабери све',
      deselectAllText: 'Поништите све',
      multipleSeparator: ', '
    },

    he: {
      noneSelectedText: 'לא נבחר דבר',
      noneResultsText: 'אין התאמה לתוצאות {0}',
      countSelectedText: 'נבחר {0} מ {1}',
      maxOptionsText: ['ההגעה הגיעה ({n} {var} מַקסִימוּם)', 'הגעת למגבלה ({n} {var} מַקסִימוּם)', ['פריטים', 'פריט']],
      doneButtonText: 'לִסְגוֹר',
      selectAllText: 'בחר הכל',
      deselectAllText: 'הסר סימון מהכל',
      multipleSeparator: ', '
    },

    hi: {
      noneSelectedText: 'कुछ भी चयनित नहीं',
      noneResultsText: 'कोई परिणाम नहीं मिला {0}',
      countSelectedText: 'चयनित {0} से {1}',
      maxOptionsText: ['सीमित पहुंच ({n} {var} ज्यादा से ज्यादा)', 'समूह सीमा तक पहुंच गया ({n} {var} ज्यादा से ज्यादा)', ['आइटम', 'मद']],
      doneButtonText: 'बंद करे',
      selectAllText: 'सभी का चयन करे',
      deselectAllText: 'सभी को अचिन्हिंत करें',
      multipleSeparator: ', '
    },

    tr: {
      noneSelectedText: 'Hiçbiri seçilmedi',
      noneResultsText: 'Hiçbir sonuç bulunamadı {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} öğe seçildi' : '{0} öğe seçildi';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'Limit aşıldı (maksimum {n} sayıda öğe )' : 'Limit aşıldı (maksimum {n} sayıda öğe)',
          numGroup === 1 ? 'Grup limiti aşıldı (maksimum {n} sayıda öğe)' : 'Grup limiti aşıldı (maksimum {n} sayıda öğe)'
        ];
      },
      selectAllText: 'Tümünü Seç',
      deselectAllText: 'Seçiniz',
      multipleSeparator: ', '
    },

    pl: {
      noneSelectedText: 'Nic nie zaznaczono',
      noneResultsText: 'Brak wyników wyszukiwania {0}',
      countSelectedText: 'Zaznaczono {0} z {1}',
      maxOptionsText: ['Osiągnięto limit ({n} {var} max)', 'Limit grupy osiągnięty ({n} {var} max)', ['elementy', 'element']],
      selectAllText: 'Zaznacz wszystkie',
      deselectAllText: 'Odznacz wszystkie',
      multipleSeparator: ', '
    },

    hu: {
      noneSelectedText: 'Válasszon!',
      noneResultsText: 'Nincs találat {0}',
      countSelectedText: function (numSelected, numTotal) {
        return '{0} elem kiválasztva';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          'Legfeljebb {n} elem választható',
          'A csoportban legfeljebb {n} elem választható'
        ];
      },
      selectAllText: 'Mind',
      deselectAllText: 'Egyik sem',
      multipleSeparator: ', '
    },

    hr: {
      noneSelectedText: 'Odaberite stavku',
      noneResultsText: 'Nema rezultata pretrage {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} stavka selektirana' : '{0} stavke selektirane';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'Limit je postignut ({n} stvar maximalno)' : 'Limit je postignut ({n} stavke maksimalno)',
          numGroup === 1 ? 'Grupni limit je postignut ({n} stvar maksimalno)' : 'Grupni limit je postignut ({n} stavke maksimalno)'
        ];
      },
      selectAllText: 'Selektiraj sve',
      deselectAllText: 'Deselektiraj sve',
      multipleSeparator: ', '
    },

    sk: {
      noneSelectedText: 'Vyberte zo zoznamu',
      noneResultsText: 'Pre výraz {0} neboli nájdené žiadne výsledky',
      countSelectedText: 'Vybrané {0} z {1}',
      maxOptionsText: ['Limit prekročený ({n} {var} max)', 'Limit skupiny prekročený ({n} {var} max)', ['položiek', 'položka']],
      selectAllText: 'Vybrať všetky',
      deselectAllText: 'Zrušiť výber',
      multipleSeparator: ', '
    },

    sv: {
      noneSelectedText: 'Inget valt',
      noneResultsText: 'Inget sökresultat matchar {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} alternativ valt' : '{0} alternativ valda';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          'Gräns uppnåd (max {n} alternativ)',
          'Gräns uppnåd (max {n} gruppalternativ)'
        ];
      },
      selectAllText: 'Markera alla',
      deselectAllText: 'Avmarkera alla',
      multipleSeparator: ', '
    },

    fi: {
      noneSelectedText: 'Ei valintoja',
      noneResultsText: 'Ei hakutuloksia {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} valittu' : '{0} valitut';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'Valintojen maksimimäärä ({n} saavutettu)' : 'Valintojen maksimimäärä ({n} saavutettu)',
          numGroup === 1 ? 'Ryhmän maksimimäärä ({n} saavutettu)' : 'Ryhmän maksimimäärä ({n} saavutettu)'
        ];
      },
      selectAllText: 'Valitse kaikki',
      deselectAllText: 'Poista kaikki',
      multipleSeparator: ', '
    },

    no: {
      noneSelectedText: 'Ingen valgt',
      noneResultsText: 'Søket gir ingen treff {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} alternativ valgt' : '{0} alternativer valgt';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'Grense nådd (maks {n} valg)' : 'Grense nådd (maks {n} valg)',
          numGroup === 1 ? 'Grense for grupper nådd (maks {n} grupper)' : 'Grense for grupper nådd (maks {n} grupper)'
        ];
      },
      selectAllText: 'Merk alle',
      deselectAllText: 'Fjern alle',
      multipleSeparator: ', '
    },

    lt: {
      noneSelectedText: 'Niekas nepasirinkta',
      noneResultsText: 'Niekas nesutapo su {0}',
      countSelectedText: function (numSelected, numTotal) {
        return numSelected === 1 ? '{0} elementas pasirinktas' : '{0} elementai(-ų) pasirinkta';
      },
      maxOptionsText: function (numAll, numGroup) {
        return [
          numAll === 1 ? 'Pasiekta riba ({n} elementas daugiausiai)' : 'Riba pasiekta ({n} elementai(-ų) daugiausiai)',
          numGroup === 1 ? 'Grupės riba pasiekta ({n} elementas daugiausiai)' : 'Grupės riba pasiekta ({n} elementai(-ų) daugiausiai)'
        ];
      },
      selectAllText: 'Pasirinkti visus',
      deselectAllText: 'Atmesti visus',
      multipleSeparator: ', '
    },

    ja: {
      noneSelectedText: '未選択',
      noneResultsText: '\'{0}\'が結果を返さない',
      countSelectedText: '{0}/{1}を選択した',
      maxOptionsText: ['上限に達した(最大{n}{var})', 'グループ上限に達した(最大{n}{var})', ['項目', '項目']],
      selectAllText: '全て選択する',
      deselectAllText: '何も選択しない',
      multipleSeparator: ', '
    },

    cs: {
      noneSelectedText: 'Nic není vybráno',
      noneResultsText: 'Žádné výsledky {0}',
      countSelectedText: 'Označeno {0} z {1}',
      maxOptionsText: ['Limit překročen ({n} {var} max)', 'Limit skupiny překročen ({n} {var} max)', ['položek', 'položka']],
      multipleSeparator: ', ',
      selectAllText: 'Vybrat Vše',
      deselectAllText: 'Odznačit Vše'
    },

    bn: {
      noneSelectedText: 'কিছুই নির্বাচিত হয়নি',
      noneResultsText: 'কোনও মিল খুঁজে পাওয়া যায় নি {0}',
      countSelectedText: '{1} থেকে {0} নির্বাচিত',
      maxOptionsText: ['সীমা পৌঁছেছে ({n} {var} সর্বোচ্চ)', 'গোষ্ঠী সীমায় পৌঁছেছে ({n} {var} সর্বোচ্চ)', ['বস্তু', 'বস্তু']],
      doneButtonText: 'ঘনিষ্ঠ',
      selectAllText: 'সমস্ত নির্বাচন করুন',
      deselectAllText: 'সব বাতিল',
      multipleSeparator: ', '
    },

    ko: {
      noneSelectedText: '선택한 항목 없음',
      noneResultsText: '일치하는 결과 없음 {0}',
      countSelectedText: '{1}개 중 {0}개 선택됨',
      maxOptionsText: ['제한에 도달함 (최대 {n} {var})', '그룹 제한에 도달함(최대 {n} {var})', ['단위', '단위']],
      doneButtonText: '닫기',
      selectAllText: '모두 선택',
      deselectAllText: '모두 취소',
    }
  }

  $.fn.selectpicker.defaults = languages[$('html').attr('lang')]

})(jQuery);
